(function () {
  'use strict';

  let angular = window.angular;
  let $ = window.jQuery;

  ToolkitTemplate.$inject = [
    '$element',
    '$timeout',
    '$uibModal',
    '$state',
    'AppUtils',
    '$translate',
    '$rootScope',
  ];

  angular.module('app').component('toolkitTemplateTable', {
    template:'<div class="col-xs-12 marginT5"><table ng-attr-id="toolkit-template-table" class="table table-hover no-wrap" style="width: 100%"><thead><tr><th></th><th></th><th></th></tr></thead></table></div>',
    controller: ToolkitTemplate,
    controllerAs: '$ctrl',
    bindings: {
      toolkitTemplates: '<',
      tools: '<',
    },
  });

  function ToolkitTemplate($element, $timeout, $uibModal, $state, utils, $translate, $root) {
    let vm = this;

    vm.$onInit = function onInit() {
      vm.toolkitTemplatesMap = vm.toolkitTemplates.reduce((map, toolkitTemplate) => {
        map[toolkitTemplate.id] = toolkitTemplate;
        return map;
      }, {});

      initToolkitTemplateTable(vm.toolkitTemplates);
    };

    function initToolkitTemplateTable(data) {
      let btnWidth = 70;

      const hasKeywords = data.some((item) => Array.isArray(item.keywords) && item.keywords.length);

      const columns = [
        {
          data: 'name',
          title: $translate.instant('entities._all.name'),
          render: function (data, type, row) {
            return row.name;
          },
        },
      ];

      columns.push({
        data: 'keywords',
        title: 'Tags',
        render: function (data) {
          if (!Array.isArray(data) || !data.length) {
            return '';
          }
          return data
            .map((keyword) => `<span class="label label-primary marginR5">${keyword}</span>`)
            .join(' ');
        },
      });

      columns.push({
        data: 'id',
        render: buttonsRenderer,
        orderable: false,
        width: btnWidth + 'px',
      });

      let dtOptions = {
        processing: true,
        searching: true,
        lengthChange: false,
        info: false,
        data: data,
        autoWidth: false,
        width: '100%',
        columns: columns,
      };

      $timeout(function () {
        const table = $element.find('#toolkit-template-table').DataTable(dtOptions);
        table.columns.adjust();
      });

      $element.on('click', '.table-buttons .btn', function () {
        let _this = $(this);

        let id = _this.data('entity');
        let op = _this.data('operation');

        switch (op) {
          case 'view':
            showToolkitTemplate(id);
            break;

          case 'unlink':
            showUnlinkModal(id);
            break;

          default:
            console.log('invalid operation');
        }
      });
    }

    function showToolkitTemplate(id) {
      const toolkitTemplate = vm.toolkitTemplatesMap[id];

      $uibModal
        .open({
          animation: false,
          bindToController: true,
          size: 'xs',
          backdrop: 'static',
          component: 'toolKitTemplateView',
          resolve: {
            toolkitTemplate: function () {
              return toolkitTemplate;
            },

            tools: function () {
              return (toolkitTemplate.toolIds || [])
                .map((toolId) => vm.tools[toolId])
                .filter(Boolean);
            },

            adminTools: function () {
              return (toolkitTemplate.adminToolIds || [])
                .map((toolId) => vm.tools[toolId])
                .filter(Boolean);
            },
          },
        })
        .result.catch(function (err) {
          console.log(err);
        });
    }
    function showUnlinkModal(id) {
      $uibModal
        .open({
          animation: true,
          backdrop: 'static',
          bindToController: true,
          windowClass: 'modal-xs modal-warning',
          component: 'toolkitTemplateUnlinkModal',
          resolve: {
            toolKitTemplate: function () {
              return vm.toolkitTemplatesMap[id];
            },
            varId: function () {
              return $root.varId;
            },
          },
        })
        .result.then(function (result) {
          $state.reload();
        })
        .catch(function (err) {
          console.log(err);
        });
    }

    function showLinkToolkitTemplateModal() {}

    function emptyRenderer(data) {
      return data || '';
    }

    function buttonsRenderer(data) {
      let buttons = '<div class="table-buttons">';

      buttons += `
                <button class="btn btn-primary btn-xs" data-operation="view" data-entity="${data}"
                    title="${$translate.instant('buttons.show')} Toolkit Template">
                    <i class="fas fa-fw fa-eye"></i>
                </button>`;

      buttons += `<button class="btn btn-danger btn-xs marginL5" data-operation="unlink" data-entity="${data}"
                        title="${$translate.instant('buttons.unlink')} Toolkit Template">
                    <i class="fas fa-fw fa-unlink"></i>
                </button>`;

      buttons += '</div>';
      return buttons;
    }
  }
})();
